export interface DevTab {
  id: string;
  label: string;
  lang: string;
  code: string;
}

// Verified connection details (host, port, and the -country-{iso} username
// modifier) match the snippets already published on the homepage API section
// (components/sections/home/api/data.ts). City/ISP targeting and rotating vs.
// sticky session mode are configured per access point in the dashboard —
// there's no documented username modifier for those to show in a snippet.
export const DEV_TABS: DevTab[] = [
  {
    id: "curl",
    label: "cURL",
    lang: "bash",
    code: `# Basic connection — checks your outbound IP
curl --proxy "http://your_username:your_password@gate.proxidize.com:7777" \\
     https://api.ipify.org?format=json

# Country targeting: append -country-{iso} to your username
curl --proxy "http://your_username-country-de:your_password@gate.proxidize.com:7777" \\
     https://api.ipify.org?format=json

# SOCKS5
curl --socks5 "your_username:your_password@gate.proxidize.com:7778" \\
     https://api.ipify.org?format=json`,
  },
  {
    id: "python",
    label: "Python",
    lang: "python",
    code: `import requests

USERNAME = "your_username"  # append -country-{iso} to target a country, e.g. "your_username-country-de"
PASSWORD = "your_password"
HOST = "gate.proxidize.com"
PORT = 7777

proxy_url = f"http://{USERNAME}:{PASSWORD}@{HOST}:{PORT}"
proxies = {"http": proxy_url, "https": proxy_url}

response = requests.get("https://api.ipify.org?format=json", proxies=proxies, timeout=30)
print(response.json())  # {"ip": "185.241.x.x"}`,
  },
  {
    id: "nodejs",
    label: "Node.js",
    lang: "javascript",
    code: `import axios from "axios";
import { HttpsProxyAgent } from "https-proxy-agent";

const USERNAME = "your_username"; // append -country-{iso} to target a country
const PASSWORD = "your_password";
const HOST = "gate.proxidize.com";
const PORT = 7777;

const proxyUrl = \`http://\${USERNAME}:\${PASSWORD}@\${HOST}:\${PORT}\`;
const agent = new HttpsProxyAgent(proxyUrl);

const { data } = await axios.get("https://api.ipify.org?format=json", { httpsAgent: agent });
console.log(data); // { ip: "185.241.x.x" }`,
  },
  {
    id: "playwright",
    label: "Playwright",
    lang: "javascript",
    code: `import { chromium } from "playwright";

const browser = await chromium.launch();
const context = await browser.newContext({
  proxy: {
    server: "http://gate.proxidize.com:7777",
    username: "your_username", // append -country-{iso} to target a country
    password: "your_password",
  },
});

const page = await context.newPage();
await page.goto("https://api.ipify.org?format=json");
console.log(await page.textContent("body"));
await browser.close();`,
  },
  {
    id: "puppeteer",
    label: "Puppeteer",
    lang: "javascript",
    code: `import puppeteer from "puppeteer";

const browser = await puppeteer.launch({
  args: ["--proxy-server=gate.proxidize.com:7777"],
});

const page = await browser.newPage();
// Append -country-{iso} to the username to target a country
await page.authenticate({ username: "your_username", password: "your_password" });
await page.goto("https://api.ipify.org?format=json");
console.log(await page.content());
await browser.close();`,
  },
];

export interface DevLink {
  label: string;
  href: string;
}
